module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8418/img/favicon.png"